import React from 'react';
import { LayoutGrid, Maximize, ToggleLeft, Layers } from 'lucide-react';
export function SizingHelp() {
  return <section className="py-24 bg-cream-dark border-y border-warmBorder" data-id="element-1255">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1256">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-1257">
          <span className="inline-block text-xs font-bold tracking-[0.2em] uppercase text-gold mb-4" data-id="element-1258">
            Configurations & Sizes
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-1259">
            Every Size You Could Possibly Need
          </h2>
          <p className="text-warmGray text-lg leading-relaxed" data-id="element-1260">
            From standard singles to oversized six-gangs, we have your size. We
            specialize in hard-to-find configurations that big box stores simply
            don't carry.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-1261">
          {/* Standard Sizes */}
          <div className="bg-white p-8 rounded-sm shadow-sm border border-warmBorder" data-id="element-1262">
            <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center mb-6" data-id="element-1263">
              <LayoutGrid className="text-gold" size={24} data-id="element-1264" />
            </div>
            <h3 className="text-xl font-serif text-charcoal mb-4" data-id="element-1265">
              Standard Sizes
            </h3>
            <ul className="space-y-3 text-warmGray" data-id="element-1266">
              <li className="flex items-center" data-id="element-1267">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1268"></span>
                Single Toggle
              </li>
              <li className="flex items-center" data-id="element-1269">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1270"></span>
                Double Toggle
              </li>
              <li className="flex items-center" data-id="element-1271">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1272"></span>
                Triple Toggle
              </li>
              <li className="flex items-center" data-id="element-1273">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1274"></span>
                Quad (4 Switches)
              </li>
            </ul>
          </div>

          {/* Large Sizes */}
          <div className="bg-white p-8 rounded-sm shadow-sm border border-warmBorder" data-id="element-1275">
            <div className="w-12 h-12 bg-sage/10 rounded-full flex items-center justify-center mb-6" data-id="element-1276">
              <Maximize className="text-sage" size={24} data-id="element-1277" />
            </div>
            <h3 className="text-xl font-serif text-charcoal mb-4" data-id="element-1278">
              Large & Oversized
            </h3>
            <ul className="space-y-3 text-warmGray" data-id="element-1279">
              <li className="flex items-center" data-id="element-1280">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1281"></span>
                Five Gang
              </li>
              <li className="flex items-center" data-id="element-1282">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1283"></span>
                Six Gang{' '}
                <span className="ml-2 text-[10px] uppercase tracking-wider bg-cream-dark px-2 py-0.5 rounded-sm font-bold" data-id="element-1284">
                  Special
                </span>
              </li>
              <li className="flex items-center" data-id="element-1285">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1286"></span>
                Oversized Plates
              </li>
              <li className="flex items-center" data-id="element-1287">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1288"></span>
                Jumbo Covers
              </li>
            </ul>
          </div>

          {/* Switch Types */}
          <div className="bg-white p-8 rounded-sm shadow-sm border border-warmBorder" data-id="element-1289">
            <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center mb-6" data-id="element-1290">
              <ToggleLeft className="text-gold" size={24} data-id="element-1291" />
            </div>
            <h3 className="text-xl font-serif text-charcoal mb-4" data-id="element-1292">
              Switch Types
            </h3>
            <ul className="space-y-3 text-warmGray" data-id="element-1293">
              <li className="flex items-center" data-id="element-1294">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1295"></span>
                Standard Toggle
              </li>
              <li className="flex items-center" data-id="element-1296">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1297"></span>
                Decora / Rocker
              </li>
              <li className="flex items-center" data-id="element-1298">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1299"></span>
                GFI / GFCI Outlets
              </li>
              <li className="flex items-center" data-id="element-1300">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1301"></span>
                Blank Covers
              </li>
            </ul>
          </div>

          {/* Combinations */}
          <div className="bg-white p-8 rounded-sm shadow-sm border border-warmBorder" data-id="element-1302">
            <div className="w-12 h-12 bg-sage/10 rounded-full flex items-center justify-center mb-6" data-id="element-1303">
              <Layers className="text-sage" size={24} data-id="element-1304" />
            </div>
            <h3 className="text-xl font-serif text-charcoal mb-4" data-id="element-1305">
              Combinations
            </h3>
            <ul className="space-y-3 text-warmGray" data-id="element-1306">
              <li className="flex items-center" data-id="element-1307">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1308"></span>
                Switch + Plug
              </li>
              <li className="flex items-center" data-id="element-1309">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1310"></span>
                Switch + Blank
              </li>
              <li className="flex items-center" data-id="element-1311">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1312"></span>
                Plug + Blank
              </li>
              <li className="flex items-center" data-id="element-1313">
                <span className="w-1.5 h-1.5 bg-gold rounded-full mr-3 flex-shrink-0" data-id="element-1314"></span>
                Custom Layouts
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-white p-8 md:p-10 rounded-sm border border-warmBorder shadow-warm flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-1315">
          <div className="max-w-2xl" data-id="element-1316">
            <h4 className="text-2xl font-serif text-charcoal mb-3" data-id="element-1317">
              Looking for an odd configuration?
            </h4>
            <p className="text-warmGray leading-relaxed" data-id="element-1318">
              If you don't see what you need, check our Special Order size chart
              where you will find many more unusual sizes. We specialize in
              custom configurations to fit any electrical box in your home.
            </p>
            <p className="mt-4 font-bold text-charcoal" data-id="element-1319">
              Call us at{' '}
              <a href="tel:8004976946" className="text-gold hover:text-gold-dark transition-colors" data-id="element-1320">
                800.497.6946
              </a>{' '}
              (9AM–5PM EST) for assistance.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 flex-shrink-0 w-full md:w-auto" data-id="element-1321">
            <a href="/size-chart" className="inline-flex justify-center items-center px-8 py-4 bg-gold text-white hover:bg-gold-dark font-bold rounded-sm transition-colors uppercase tracking-wider text-sm shadow-sm" data-id="element-1322">
              View Size Chart
            </a>
            <a href="/special-order-sizes" className="inline-flex justify-center items-center px-8 py-4 bg-transparent border-2 border-gold text-gold hover:bg-gold hover:text-white font-bold rounded-sm transition-colors uppercase tracking-wider text-sm" data-id="element-1323">
              Special Orders
            </a>
          </div>
        </div>
      </div>
    </section>;
}